var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6897 5.25005L12.7062 0.307689C12.5094 0.112526 12.2364 0 11.9572 0H6.8823C5.42322 0 4.2354 1.17801 4.2354 2.62502V3.67468H2.6469C1.18783 3.67468 0 4.85269 0 6.29971V16.275C0 17.722 1.18783 18.9 2.6469 18.9H11.1177C12.5768 18.9 13.7646 17.722 13.7646 16.275V15.2253H15.3531C16.8122 15.2253 18 14.0473 18 12.6003V5.9929C18 5.71598 17.8865 5.44521 17.6897 5.25005ZM12.7062 1.79251L16.1926 5.25005H14.2938C13.418 5.25005 12.7053 4.54324 12.7053 3.67468L12.7062 1.79251ZM12.7062 16.2759C12.7062 17.1444 11.9935 17.8512 11.1177 17.8512H2.6469C1.7711 17.8512 1.05841 17.1444 1.05841 16.2759V6.30059C1.05841 5.43202 1.7711 4.72522 2.6469 4.72522H7.4115V7.35024C7.4115 8.79726 8.59933 9.97527 10.0584 9.97527H12.7053L12.7062 16.2759ZM8.4708 7.35024V5.46807L11.9572 8.92561H10.0584C9.18261 8.92561 8.4708 8.21881 8.4708 7.35024ZM16.9407 12.6003C16.9407 13.4689 16.228 14.1757 15.3522 14.1757H13.7637V9.66758C13.7637 9.39154 13.6503 9.12077 13.4535 8.92473L8.4708 3.98237C8.27401 3.78721 8.00099 3.67468 7.72176 3.67468H5.2938V2.62502C5.2938 1.75646 6.0065 1.04966 6.8823 1.04966H11.6469V3.67468C11.6469 5.1217 12.8347 6.29971 14.2938 6.29971H16.9407V12.6003Z",
    fill: "#FF425E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic_copy.7959b19cf39489b122ecaf64bb04fb50.svg";
export { ForwardRef as ReactComponent };